import React from 'react';
import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { projectRevenueTableHeader } from '../utils/projectRevenueTableHeader';
import { useSelector } from 'react-redux';

const ProjectRevenueTable = () => {
  const projectPerformanceSummary = useSelector((state) => state.pointTracker.projectPerformanceSummary.data);
  const projectPerformanceSummaryLoading = useSelector((state) => state.pointTracker.projectPerformanceSummary.loading);

  return (
    <GlobalTableGenerator
      rows={projectPerformanceSummary?.tableData}
      columns={projectRevenueTableHeader}
      loading={projectPerformanceSummaryLoading}
      TableHeadStyle={{ bgcolor: '#00b8dc' }}
      TableContainerStyle={{
        border: '1px solid #00b8dc',

        '& .MuiTableCell-head': {
          border: '1px solid #0094bd',
        },
      }}
    />
  );
};
export default React.memo(ProjectRevenueTable);
